import { symmetricDifference, isEmpty, equals } from "ramda";
import memoizeOne from "memoize-one";
import passwordValidator from "../../../lib/passwordValidator";

const incompleteChallenges = memoizeOne((value, rules) => {
  const validator = passwordValidator(rules);
  return validator(value);
}, equals);

const requiredChallenges = memoizeOne(rules => {
  const validator = passwordValidator(rules);
  return validator("");
}, equals);

const PasswordComplexity = ({ value, rules, render, ...restProps }) => {
  const incomplete = incompleteChallenges(value, rules);
  const required = requiredChallenges(rules);

  return render({
    invalid: !isEmpty(incomplete),
    challenges: required,
    completedChallenges: symmetricDifference(incomplete, required),
    ...restProps
  });
};

export default PasswordComplexity;
